import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import * as serviceWorker from './serviceWorker';
import {ThemeProvider} from 'styled-components';
import theme from './theme/theme';
import { BrowserRouter as Router } from 'react-router-dom';
//import { subscribeUser } from './subscription';

ReactDOM.render(
  <React.StrictMode>
  <Router>
     <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
    </Router>,
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
//subscribeUser()